// authService.js
import { toast } from "@3sc/common-component";
import i18next from "i18next";
import { logout, tokenRefresh, tokenVerify } from "../utils/ApiHandler";
import { ROUTES_PATH } from "../utils/EndPoints";

export const verifyToken = async (accessToken) => {
  try {
    const res = await tokenVerify();
    if (res.status === 200) {
      return true;
    }
  } catch (error) {
    throw error;
  }
};

export const refreshAccessToken = async (refreshToken, authenticator) => {
  try {
    const res = await tokenRefresh(refreshToken, authenticator);
    if (res.status === 200) {
      return true;
    }
  } catch (error) {
    throw error;
  }
};

export const handleAuthError = (error, navigate, dispatch) => {
  const resErr = error?.response?.data?.RESPONSE_CODE || error?.response?.data;
  resErr && toast.error(i18next.t(resErr));
  logout(navigate, dispatch);
  navigate(ROUTES_PATH.ROUTE);
};
